import { render, staticRenderFns } from "./levels-statistic.vue?vue&type=template&id=2bfdde72"
import script from "./levels-statistic.vue?vue&type=script&lang=js"
export * from "./levels-statistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports